export const ApplyAnchor = () => {
    return {
        anchorHideClasses: ['opacity-0', 'invisible', 'pointer-events-none'],
        anchor: document.querySelector('.anchor-apply'),
        form: document.querySelector('.apply-form'),
        observer: null,

        init() {
            if(!this.form) return;
            this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            });
            this.observer.observe(this.form);
        },

        handleIntersect(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.anchor.classList.add(...this.anchorHideClasses);
                } else {
                    this.anchor.classList.remove(...this.anchorHideClasses);
                }
            });
        }
    }
}